import { useCreation } from "ahooks";
import { Button, Modal } from "antd";
import func from "@uikit/func";
import styles from "./Delete.module.scss";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { DeleteBloc, DeleteBlocState } from "./DeleteBloc";
import { useHomeChildContainer } from "@custom-hooks/HomeUsePluginRoot/childContainer";
import { usePreviewAppStore } from "@custom-hooks/HomeUsePluginRoot/usePreviewAppStore";
import { PowerMaskView } from "@uiview/views/PowerMask/PowerMaskView";
import { logEvent } from "@uikit/service/amplitude";

const CLOSE_ICON = "https://dopniceu5am9m.cloudfront.net/static/assets/230705/ACAEB5Cross.svg";
const TITLE = "Are you sure you want to Delete?";
const SUBTITLE = "Permanently delete this publish view. You cannot undo this action.";

export function Delete() {
  const state = new DeleteBlocState();
  const bloc = useCreation(() => new DeleteBloc(state), []);

  const { handleSave } = useHomeChildContainer();
  const { getPublishMetadata, getSelectedTemplate, deletePreviewV2App, returnToPreviewList, previewAppActiveIdSignal } =
    usePreviewAppStore();

  const published_metadata = getPublishMetadata();
  const disabledUnPublish = func.isEmpty(published_metadata?.link);

  async function handleOk() {
    try {
      bloc.state.deleteLoading.value = true;
      // 删除本地数据
      deletePreviewV2App(previewAppActiveIdSignal.value);
      // 调用接口更新数据
      if (!disabledUnPublish) {
        await handleSave({ background: true });
      }
      returnToPreviewList();
      func.customMsg({
        content: "successfully",
        type: "success",
      });
      logEvent("delete_publish_view", bloc.getDeleteEventProps(published_metadata, getSelectedTemplate()));
    } catch (error) {
      func.messageError(error);
    } finally {
      bloc.state.deleteLoading.value = false;
      bloc.handleCancel();
    }
  }

  return (
    <PowerMaskView feature={[]}>
      <div className={styles.deleteBox}>
        <div className={styles.title}>Delete</div>
        <div className={styles.subTitle}>Permanently delete this publish view. You cannot undo this action.</div>
        <div className={styles.buttonBox} onClick={() => bloc.showDeleteModal()}>
          Delete this publish view
        </div>

        {bloc.state.showModal.value && (
          <div className={styles.modalRoot}>
            <Modal
              open={bloc.state.showModal.value}
              wrapClassName={styles.modalWrap}
              width="400px"
              centered={true}
              closeIcon={<img src={CLOSE_ICON} width="20" height="20" alt="close" />}
              footer={null}
              onOk={handleOk}
              onCancel={() => bloc.handleCancel()}
            >
              <ExclamationCircleOutlined className={styles.modalIcon} />
              <span className={styles.modalTitle}>{TITLE}</span>
              <p className={styles.modalSubtitle}>{SUBTITLE}</p>
              <div className={styles.modalFooter}>
                <Button
                  data-testid="Preview-Settings-Unpublish-Cancel"
                  shape="round"
                  size="large"
                  type="default"
                  className={styles.modalButtonNormal}
                  onClick={() => bloc.handleCancel()}
                >
                  Cancel
                </Button>
                <Button
                  data-testid="Preview-Settings-Unpublish-Confirm"
                  shape="round"
                  size="large"
                  className={styles.modalButtonDanger}
                  loading={bloc.state.deleteLoading.value}
                  onClick={handleOk}
                >
                  Delete
                </Button>
              </div>
            </Modal>
          </div>
        )}
      </div>
    </PowerMaskView>
  );
}
